import React from 'react';
import TimelineIcon from '@material-ui/icons/Timeline';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import AssessmentIcon from '@material-ui/icons/Assessment';
import WorkIcon from '@material-ui/icons/Work';
import WarningIcon from '@material-ui/icons/Warning';
import SubjectIcon from '@material-ui/icons/Subject';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import TableChartIcon from '@material-ui/icons/TableChart';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import CardTravelIcon from '@material-ui/icons/CardTravel';
import TodayIcon from '@material-ui/icons/Today';
import ReportIcon from '@material-ui/icons/Report';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ChatIcon from '@material-ui/icons/Chat';
import GradeIcon from '@material-ui/icons/Grade';
import ListAltIcon from '@material-ui/icons/ListAlt';
import FaceIcon from '@material-ui/icons/Face';
import SchoolIcon from '@material-ui/icons/School';

import MenuItemLabel from './parts/Menu/MenuItemLabel';
import BehaviourPage from './logged/BehaviourPage';
import ParentBehaviourPage from './logged/ParentBehaviourPage';
import AnnouncementsPage from './logged/AnnouncementsPage';
import ReportCardsPage from './logged/ReportCardsPage';
import HomeworkPage from './logged/HomeworkPage';
import DetentionsPage from './logged/DetentionsPage';
import ClassesPage from './logged/ClassesPage';
import MentalHealthPage from './logged/MentalHealthPage';
import TimetablePage from './logged/TimetablePage';
import AttendancePage from './logged/AttendancePage';
import RewardsPage from './logged/RewardsPage';
import AbsencesPage from './logged/AbsencesPage';
import ReportConcernPage from './logged/ReportConcernPage';
import CovidTestsPage from './logged/CovidTestsPage';
import AcademicReportsPage from './logged/AcademicReportsPage';
import MobileMessagesPage from './logged/MobileMessagesPage';
import DesktopMessagesPage from './logged/DesktopMessagesPage';
import EventBadgesPage from './logged/EventBadgesPage';
import CustomFieldsPage from './logged/CustomFieldsPage';
import AvatarsPage from './logged/AvatarsPage';

export function getPupilMenuItems(pupil, user, threadsDefaultSearch, isDesktop) {
  const items = {};

  if (pupil?.display_behaviour) {
    items.behaviour = {
      key: 'behaviour',
      icon: <TimelineIcon />,
      label: <MenuItemLabel type="behaviour" />,
      component: <BehaviourPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_parent_behaviour) {
    items.parent_behaviour = {
      key: 'parent_behaviour',
      icon: <AddCircleOutlineIcon />,
      label: <MenuItemLabel type="parent_behaviour" />,
      component: <ParentBehaviourPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_announcements) {
    items.announcements = {
      key: 'announcements',
      icon: <VolumeUpIcon />,
      label: <MenuItemLabel type="announcements" pupil={pupil} />,
      component: <AnnouncementsPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_report_cards) {
    items.report_cards = {
      key: 'report_cards',
      icon: <AssessmentIcon />,
      label: <MenuItemLabel type="report_cards" />,
      component: <ReportCardsPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_homework) {
    items.homework = {
      key: 'homework',
      icon: <WorkIcon />,
      label: <MenuItemLabel type="homework" pupil={pupil} />,
      component: <HomeworkPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_detentions) {
    items.detentions = {
      key: 'detentions',
      icon: <WarningIcon />,
      label: <MenuItemLabel type="detentions" pupil={pupil} />,
      component: <DetentionsPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_classes) {
    items.classes = {
      key: 'classes',
      icon: <SubjectIcon />,
      label: <MenuItemLabel type="classes" />,
      component: <ClassesPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_mental_health) {
    items.tracking = {
      key: 'tracking',
      icon: <InsertEmoticonIcon />,
      label: <MenuItemLabel type="tracking" user={user} />,
      component: <MentalHealthPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_timetable) {
    items.timetable = {
      key: 'timetable',
      icon: <TableChartIcon />,
      label: <MenuItemLabel type="timetable" />,
      component: <TimetablePage key={pupil.id} useSuspense={false} />,
      mobileWithoutContainer: true,
    };
  }

  if (pupil?.display_attendance) {
    items.attendance = {
      key: 'attendance',
      icon: <AccessTimeIcon />,
      label: <MenuItemLabel type="attendance" />,
      component: <AttendancePage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_rewards) {
    items.rewards = {
      key: 'rewards',
      icon: <CardTravelIcon />,
      label: <MenuItemLabel type="rewards" />,
      component: <RewardsPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_absences) {
    items.absences = {
      key: 'absences',
      icon: <TodayIcon />,
      label: <MenuItemLabel type="absences" />,
      component: <AbsencesPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_concern_submission) {
    items.report_concern = {
      key: 'report_concern',
      icon: <ReportIcon />,
      label: <MenuItemLabel type="report_concern" />,
      component: <ReportConcernPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_academic_reports) {
    items.academic_reports = {
      key: 'academic_reports',
      icon: <SchoolIcon />,
      label: <MenuItemLabel type="academic_reports" />,
      component: <AcademicReportsPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_covid_tests) {
    items.covid_tests = {
      key: 'covid_tests',
      icon: <AssignmentIcon />,
      label: <MenuItemLabel type="covid_tests" />,
      component: <CovidTestsPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_two_way_communications) {
    items.messages = {
      key: 'messages',
      icon: <ChatIcon />,
      label: <MenuItemLabel type="messages" pupil={pupil} />,
      component: isDesktop
        ? <DesktopMessagesPage key={pupil.id} useSuspense={false} />
        : <MobileMessagesPage key={pupil.id} threadsDefaultSearch={threadsDefaultSearch} useSuspense={false} />,
      mobileWithoutContainer: true,
      desktopWithoutContainer: true,
    };
  }

  if (pupil?.display_event_badges) {
    items.event_badges = {
      key: 'event_badges',
      icon: <GradeIcon />,
      label: <MenuItemLabel type="event_badges" />,
      component: <EventBadgesPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_custom_fields) {
    items.custom_fields = {
      key: 'custom_fields',
      icon: <ListAltIcon />,
      label: <MenuItemLabel type="custom_fields" />,
      component: <CustomFieldsPage key={pupil.id} useSuspense={false} />,
    };
  }

  if (pupil?.display_avatars) {
    items.avatars = {
      key: 'avatars',
      icon: <FaceIcon />,
      label: <MenuItemLabel type="change_avatar" />,
      component: <AvatarsPage key={pupil.id} useSuspense={false} />,
    };
  }

  return items;
}
